module.exports = __webpack_public_path__ + "img/phone3-icon.be259c1d.png";